import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";

import ScreenLayout from "./containers/ScreenLayout";
import FullPageLoader from "./containers/FullPageLoader";
import config from "./miniapp.config";

const HomeScreen = lazy(() => import("./screens/HomeScreen"));
const ClickerScreen = lazy(() => import("./screens/ClickerScreen"));
const DashboardScreen = lazy(() => import("./screens/DashboardScreen"));
const NotFoundScreen = lazy(() => import("./screens/NotFoundScreen"));
const MaintenanceScreen = lazy(() => import("./screens/MaintenanceScreen"));

function App() {
  // Check if app is under maintenance
  if (config.UNDER_MAINTENANCE) {
    return (
      <ScreenLayout>
        <Suspense fallback={<FullPageLoader />}>
          <MaintenanceScreen />
        </Suspense>
      </ScreenLayout>
    );
  }

  return (
    <ScreenLayout>
      <BrowserRouter>
        <Suspense fallback={<FullPageLoader />}>
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/clicker/*" element={<ClickerScreen />} />
            <Route path="/dashboard" element={<DashboardScreen />} />
            <Route path="*" element={<NotFoundScreen />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ScreenLayout>
  );
}

export default App;
